



































import { Component, Vue } from 'vue-property-decorator'
import { ApiService } from '@/api/api.service'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import ModulesList from '@/components/ModulesList.vue'
import { tooltipAtelier } from '@/data/tooltips'

@Component({
    components: {
        SmoothReflow,
        ModulesList,
    },
})
export default class Programmation extends Vue {
    filter = 'all'

    get tooltipAtelier() {
        return tooltipAtelier
    }

    mounted() {
        requestAnimationFrame(() => {
            const $popoverDismiss = $('.popover-dismiss') as any
            $popoverDismiss.popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })
    }
}
